// Reads PDF / DOCX / TXT in the browser and returns {text, warning}.
export const extractText = async (file) => {
  const name = file.name.toLowerCase();
  if (name.endsWith(".txt") || file.type === "text/plain") return { text: await file.text() };
  if (name.endsWith(".docx")) {
    const mammoth = await import("mammoth/mammoth.browser");
    const r = await mammoth.extractRawText({ arrayBuffer: await file.arrayBuffer() });
    const text = r.value.trim();
    return { text, warning: !text ? "No readable text found in this document." : r.messages?.length ? "Some parts of the document (images, embedded objects) could not be read." : null };
  }
  if (name.endsWith(".pdf")) {
    const pdfjs = await import("pdfjs-dist/build/pdf");
    pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;
    const doc = await Promise.race([pdfjs.getDocument({ data: await file.arrayBuffer() }).promise, new Promise((_, no) => setTimeout(() => no(new Error("Reading the PDF took too long")), 20000))]);
    const pages = [];
    let empty = 0;
    for (let i = 1; i <= doc.numPages; i++) {
      const c = await (await doc.getPage(i)).getTextContent();
      const t = c.items.map((x) => x.str + (x.hasEOL ? "\n" : " ")).join("").trim();
      if (!t) empty++;
      pages.push(t);
    }
    const text = pages.join("\n\n").trim();
    return { text, warning: !text ? "This PDF looks scanned (images only). Paste the text instead." : empty ? `${empty} of ${doc.numPages} pages had no readable text and were left out. Please check.` : null };
  }
  throw new Error("Use a PDF, DOCX or TXT file.");
};
